// reducers/ticketReducer.js



import {SET_TICKET_REFRESH} from "../../actions";

const initialState = {
    needRefresh: false,
};

export function supportReducer(state = initialState, action) {
    switch (action.type) {
        case SET_TICKET_REFRESH:
            return {
                ...state,
                needRefresh: action.payload,
            };

        default:
            return state;
    }
}